import type { users as en } from '@/i18n/locales/en/users';
import type { Translation } from '@/i18n/types';

export const users: Translation<typeof en> = {
  page: {
    title: 'Χρήστες',
    noScope:
      'Δεν έχετε κανένα διαχειριστικό πεδίο εφαρμογής, οπότε δεν υπάρχει λίστα μελών για εμφάνιση.',
    departmentListsTitle: 'Λίστες μελών τμημάτων',
    leadCompany: 'Μέλη της {{company}}.',
    membersOf: 'Μέλη της {{company}}',
    companyMembersCardTitle: 'Μέλη',
    addPerson: 'Προσθήκη ατόμου',
    empty: 'Δεν υπάρχουν μέλη.',
    name: 'Όνομα',
    email: 'Email',
    login: 'Σύνδεση',
    source: 'Προέλευση',
    yes: 'ναι',
    no: 'όχι',
    invitePerson: 'Πρόσκληση',
    importCsv: 'Εισαγωγή CSV',
    searchPlaceholder: 'Αναζήτηση με όνομα ή email…',
    filterDepartment: 'Τμήμα',
    allDepartments: 'Όλα τα τμήματα',
    filterLocation: 'Τοποθεσία',
    allLocations: 'Όλες οι τοποθεσίες',
    filterStatus: 'Κατάσταση',
    allStatuses: 'Όλες οι καταστάσεις',
    employee: 'Εργαζόμενος',
    department: 'Τμήμα',
    location: 'Τοποθεσία',
    lastSync: 'Τελευταίος συγχρονισμός',
    consent: 'Συγκατάθεση',
    wearable: 'Wearable',
    pilot: 'Πιλότος',
    account: 'Λογαριασμός',
    actions: 'Ενέργειες',
    accountActive: 'Ενεργός',
    accountDeactivated: 'Απενεργοποιημένος',
    noLocation: 'Καμία τοποθεσία',
    noDepartment: 'Κανένα τμήμα',
    activation: {
      label: 'Ενεργοποίηση',
      invited: 'Προσκλήθηκε',
      activated: 'Ενεργοποιήθηκε',
      active: 'Ενεργός',
      inactive: 'Ανενεργός',
      deactivated: 'Απενεργοποιήθηκε',
    },
    consentStatus: {
      pending: 'Σε εκκρεμότητα',
      confirmed: 'Επιβεβαιώθηκε',
      declined: 'Ανακλήθηκε',
      none: 'Καμία',
    },
  },
  detail: {
    thisPerson: 'αυτό το άτομο',
    edit: 'Επεξεργασία',
    name: 'Όνομα',
    email: 'Email',
    nickname: 'Ψευδώνυμο',
    preferredLanguage: 'Προτιμώμενη γλώσσα',
    region: 'Περιοχή',
    login: 'Σύνδεση',
    yes: 'ναι',
    no: 'όχι',
    gender: 'Φύλο',
    birthdate: 'Ημερομηνία γέννησης',
    height: 'Ύψος',
    weight: 'Βάρος',
    privateNote:
      'Το φύλο, η ημερομηνία γέννησης, το ύψος και το βάρος είναι ιδιωτικά στοιχεία αυτού του ατόμου και δεν αποτελούν μέρος της προβολής που έχουν οι άλλοι για αυτό.',
    actionsCardTitle: 'Ενέργειες',
    statsCardTitle: 'Στατιστικά',
  },
  edit: {
    title: 'Επεξεργασία προσωπικών στοιχείων',
    lead: 'Το όνομα και το email προέρχονται από τον λογαριασμό σύνδεσης και δεν μπορούν να αλλάξουν εδώ.',
    cancel: 'Ακύρωση',
    save: 'Αποθήκευση',
  },
  addPerson: {
    created: 'Το άτομο δημιουργήθηκε.',
    inviteSent: 'Ένα email πρόσκλησης είναι καθ’ οδόν.',
    alreadyHasLogin: 'Έχουν ήδη σύνδεση.',
    noLoginYet:
      'Δεν έχουν ακόμη σύνδεση — μπορείτε να τους προσκαλέσετε αργότερα από τη λίστα μελών.',
    done: 'Ολοκληρώθηκε',
    name: 'Όνομα',
    email: 'Email',
    emailHint: 'Προαιρετικό — με ένα, το άτομο προσκαλείται να συνδεθεί.',
    nickname: 'Ψευδώνυμο',
    region: 'Περιοχή',
    conflict:
      'Υπάρχει ήδη ένα άτομο με αυτή τη διεύθυνση email{{reason}}. Προσθέστε αυτό το υπάρχον άτομο στο πεδίο εφαρμογής αντί να δημιουργήσετε διπλότυπο.',
    cancel: 'Ακύρωση',
    create: 'Δημιουργία ατόμου',
    companyTitle: 'Προσθήκη ατόμου στην εταιρεία',
    departmentTitle: 'Προσθήκη ατόμου στο τμήμα',
    newPersonCardTitle: 'Νέο άτομο',
    existingCardTitle: 'Υπάρχον μέλος εταιρείας',
    existingPersonCardTitle: 'Υπάρχον άτομο',
    member: 'Μέλος',
    person: 'Άτομο',
    choose: 'Επιλέξτε…',
    addToDepartment: 'Προσθήκη στο τμήμα',
    addToCompany: 'Προσθήκη στην εταιρεία',
    searchPeople: 'Αναζήτηση ατόμων',
    searchPlaceholder: 'Όνομα ή email',
    noEligible: 'Δεν βρέθηκε κανένα αντίστοιχο άτομο.',
    editionMismatch:
      'Η έκδοση αυτού του ατόμου διαφέρει από αυτή της εταιρείας. Αλλάξτε πρώτα την έκδοση του ατόμου ή της εταιρείας και δοκιμάστε ξανά.',
  },
  actions: {
    invite: 'Πρόσκληση',
    inviteAgain: 'Πρόσκληση ξανά',
    changeEmail: 'Αλλαγή email',
    newEmail: 'Νέα διεύθυνση email',
    save: 'Αποθήκευση',
    cancel: 'Ακύρωση',
    remove: 'Αφαίρεση',
    unlink: 'Αποσύνδεση',
    unlinkFromPilot: 'Αποσύνδεση από πιλοτικό',
    erase: 'Διαγραφή',
    changeLocation: 'Αλλαγή τοποθεσίας',
    changeDepartment: 'Αλλαγή τμήματος',
    deactivate: 'Απενεργοποίηση',
    activate: 'Ενεργοποίηση',
  },
  invite: {
    title: 'Πρόσκληση ατόμου',
    name: 'Όνομα',
    email: 'Διεύθυνση email',
    role: 'Ρόλος',
    roleMember: 'Εργαζόμενος',
    roleAdmin: 'Διαχειριστής εταιρείας',
    submit: 'Πρόσκληση',
    cancel: 'Ακύρωση',
  },
  import: {
    title: 'Εισαγωγή CSV',
    instructions: 'Επικολλήστε ή ανεβάστε ένα CSV με στήλες: όνομα, email, τμήμα, τοποθεσία.',
    csvLabel: 'CSV',
    placeholder: 'Jane Doe,jane@example.com,Sales,DC Rotterdam',
    uploadLabel: 'Ή ανεβάστε ένα αρχείο',
    submit: 'Εισαγωγή',
    cancel: 'Ακύρωση',
    done: 'Ολοκληρώθηκε',
    summary: '{{imported}} εισήχθησαν, {{failed}} απέτυχαν.',
    rowLabel: 'Γραμμή {{row}}',
    rowSuccess: 'Εισήχθη',
    rowFailed: 'Απέτυχε',
  },
};
